import ReactDOM from 'react-dom';
import {
  AnyObject,
  AppComponent,
  UnknownObject,
} from '@js/core/types/core-types';

export const withAppComponent = <P extends AnyObject = UnknownObject>(
  Component: AppComponent<P>
) => {
  const EnhancedComponent: AppComponent<P> = (props) => {
    return (
      <>
        <Component {...props} />
        {ReactDOM.createPortal(
          <span
            data-app-component-trace={props.id}
            aria-hidden="true"
            style={{
              visibility: 'hidden',
              pointerEvents: 'none',
            }}
          ></span>,
          document.body
        )}
      </>
    );
  };

  EnhancedComponent.displayName = `withAppComponent-${Component.displayName}`;

  return EnhancedComponent;
};
